<template>
  <div class="JOB-LIST-PLACEHOLDER" selenium="job-list-placeholder">
    <img v-if="placeholder.imageSrc" :alt="jobsStatusAlias" :src="placeholder.imageSrc" />
    <h6 v-if="placeholder.title" class="h6 m-t-0 m-b-1" selenium="job-list-placeholder-title">
      {{ placeholder.title }}
    </h6>
    <p
        v-if="placeholder.description"
        v-html="placeholder.description"
        class="text-lg c-gray60"
        selenium="job-list-placeholder-description"
    />
  </div>
</template>

<script>
import jobParams from '@/mixins/job-params';

import NEW from './assets/new.svg';
import potential from './assets/potential.svg';
import hired from './assets/hired.svg';
import completed from './assets/completed.svg';
import past from './assets/past.svg';

export default {
  name: 'job-list-placeholder',
  mixins: [
    jobParams,
  ],
  data () {
    return {
      placeholders: {
        new: {
          imageSrc: NEW,
          title: 'Check back here for new leads',
          description: `Curious how Pro Referral works? Check out the <a href="${
            this.$runtimeConstants.SALESFORCE_HELP_CENTER
          }" target="_blank" class="link">Help Center</a>`,
        },
        potential: {
          imageSrc: potential,
          title: 'Track your potential jobs',
          description:
            'Leads you’ve contacted will show up here until you mark them as hired or not',
        },
        hired: {
          imageSrc: hired,
          title: 'Organize your active jobs',
          description: 'To keep track of jobs in-progress, mark them as “Hired”',
        },
        completed: {
          imageSrc: completed,
          title: 'Get more reviews from customers',
          description:
            'Marking finished jobs as "Complete" will remind your clients to leave reviews',
        },
        past: {
          imageSrc: past,
          title: 'All archived jobs go here',
          description: 'Passed and canceled',
        },
        search: {
          title: 'No jobs found',
          description:
            'You can search by name, job type, location or description',
        },
      },
    };
  },
  computed: {
    placeholder () {
      return this.placeholders[this.jobsStatusAlias] || {};
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .JOB-LIST-PLACEHOLDER {
    @include padding(8 4 0, $md: 8 5 0);
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
</style>
